module.exports = __webpack_public_path__ + "Xavier_Valenti_Web_Over.jpg?8b89940c2594cbace893f2c7102186ca";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/Xavier_Valenti_Web_Over.jpg
// module id = 175
// module chunks = 0